<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col  cols="12">
          <b-card>
            <div slot="header" >
              <strong>Calendar</strong>
            </div>

            <div class="wapper_header mb-5">
              <div class="text-center">
                <img src="../../../../public/img/logo-mfu.png" alt="" height="100px" class="mb-1">
                <p>{{this.title}}</p>
              </div>
            </div>



            <b-row class="justify-content-center">
              <b-col cols="6">
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text> Officer Code</b-input-group-text></b-input-group-prepend>
                  <b-form-input  type="text" class="form-control" placeholder="Username" v-model="officerCode" />
                  <b-button  variant="primary" @click="this.onSearchPermi" class="mr-sm-1"><i class="fa fa-search"></i> Search</b-button>
                </b-input-group>
              </b-col>

            </b-row>



          </b-card>
        </b-col>

        <b-col  cols="12">
          <b-card>
            <div slot="header" >
              <strong>Infomation</strong>
            </div>


            <b-row>
              <b-col>
                <b-form-group label="Code" :label-cols="4">
                  <b-form-input type="text" class="form-control"  v-model="info.OFFICERCODE" disabled/>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Name" :label-cols="4">
                  <b-form-input type="text" class="form-control"  v-model="info.FULLNAME" disabled/>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Withdrow User Group" :label-cols="4">
                  <b-form-select size="sm"
                                 :plain="true"
                                 @change="changePermits($event)"
                                 :options="itemPermits"
                                 :value="info.WITHDRAW_USERGROUPID"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Active / Inactive" :label-cols="4">
                  <b-form-select size="sm"
                                 :plain="true"
                                 @change="changeStatus($event)"
                                 :options="objStatus"
                                 :value="info.PERMISSION_STATUS"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>


<!--            <b-row>-->
<!--              <b-col>-->
<!--                <b-form-group label="Remark" :label-cols="4">-->
<!--                  <b-form-input type="text" class="form-control"  v-model="remark"/>-->
<!--                </b-form-group>-->
<!--              </b-col>-->
<!--            </b-row>-->

            <b-row>
              <b-col class="text-right">
                <b-button :disabled="info.OFFICERID == null" variant="success" class=" text-white"  @click="onSubmit()">Submit</b-button>
              </b-col>
            </b-row>


          </b-card>
        </b-col>
      </b-row>


      <b-modal
          :header-bg-variant="this.dialog.type"
          header-text-variant="light"
          :class="this.dialog.style"
          v-model="this.dialog.status"
          @ok="actionDialog()"
          :ok-variant="this.dialog.type"
          ok-only>
        {{this.dialog.message}}
      </b-modal>

    </div>
  </div>
</template>

<script>
  import Service from "../../../service/api"
  export default {
    components: {
      Service},
    name: 'Calender',
    data () {
      return {
        state : false,
        stateDetail : false,
        disabled: false,
        title:"DIVISION OF REGISTRAR, MAE FAH LUANG UNIVERSITY",
        officerCode:"",
        info:{
          "FULLNAME": "",
          "OFFICERCODE": "",
          "OFFICERID": null,
          "PERMISSION_STATUS": null,
          "REMARK": "ป",
          "UPDATEDATETIME": "",
          "WITHDRAW_USERGROUPID": null
        },
        objStatus:[{
          text:"Active",
          value:1
        },{
          text:"Inactive",
          value:2
        }],
        itemPermits:[{
          text:"เจ้าหน้าที่ทะเบียน",
          value:1
        },{
          text:"คณบดี",
          value:2
        },{
          text:"เจ้าหน้าที่ IT",
          value:3
        },{
          text:"คณบดี  อาจารย์ ที่ปรึกษา",
          value:4
        }],
        dialog : {
          message : '',
          type : 'danger',
          style : 'modal-danger',
          status : false,
        },
      }
    },

    methods: {

      onInit(){
        Service.onGetPermiStatus().then((response) => {
          console.log(response)

        }).catch((error) => {

        });

      },


      onSearchPermi(){
        console.log(this.officerCode)

        Service.onGetPerMisstion(this.officerCode).then((response) => {
          this.info = response.data.data[0]
          console.log(response)

        }).catch((error) => {

        });
      },

      changePermits: function(evt) {
        this.info.WITHDRAW_USERGROUPID = evt
      },

      changeStatus: function(evt) {
        this.info.PERMISSION_STATUS = evt
      },

      onSubmit(){
        var arr = [];
        arr.push(this.info);
        var data = {};
        data.data = arr
        Service.onUpdatePermi(data).then((response) => {
          this.dialog = {
            message : response.data.message,
            type : 'success',
            style : 'modal-success',
            status : true,
          }

        }).catch((error) => {

        });
      }

    },
    mounted() {


    },
    created () {
      this.onInit();
    },
  }


</script>
<style>
  .line-container .item-symbol {
    box-sizing: border-box;
    position: absolute;
    left: -1.75rem;
    z-index: 1;
    background: white;
  }
</style>
